module.exports = __webpack_public_path__ + "img/Nutricia-big-logo.cacf7edf.svg";